import request from "./request";

export const sendMsg=(data)=>{
  console.log("data",data)
  return request({
    url: 'hgyapi/back/mail',
    data:data,
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
  })
}

export const official=(data)=>{
  return request({
    url: 'hgyapi/back/official',
    params:data,
    method: 'get',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
  })
}



// WEBPACK FOOTER //
// ./src/api/backend.js